import LnResultIcon from "components/LnResultIcon";
import React  from "react";
import classes from "./Attendance.module.scss";

const CellRender = ({ value }) => {

    let icon;
    if( value === undefined || !value.state){
         icon = "absence";
    }
    else{
         icon = value.state.Present ? "approvedbyteacher" : "failed";
    }
        return <div className={classes.iconCell} ><LnResultIcon className="icon-medium m-auto" status={icon} /></div>

}

export default CellRender;